export enum PriceActionTypes {
  Showing = 'Showing',
  Sending = 'Sending',
}

export interface IPeriod {
  hours: number;
  minutes: number;
}

export interface IPeriodTime {
  from: IPeriod;
  to: IPeriod;
}
